import { h } from "preact";
import style from "./style.scss";
import accordeon from "./accordeon.scss";
import Header from "../../components/header";
import { useContext, useRef, useState } from "preact/hooks";
import { TranslateContext } from "@denysvuika/preact-translate";
import Feedback from "../home/feedback";
import { useRefSize } from "../../utils";
export const exampleData = {
  image:
    "https://w-dog.ru/wallpapers/9/15/323582683371937/manarola-noch-provinciya-la-speciya-liguriya-severnaya-italiya-zvezdy-gorod-italiya-region-liguriya-provinciya-speciya-nacionalnyj-park-chinkve-terre.jpg",
  usp: [
    {
      image:
        "https://w-dog.ru/wallpapers/9/15/323582683371937/manarola-noch-provinciya-la-speciya-liguriya-severnaya-italiya-zvezdy-gorod-italiya-region-liguriya-provinciya-speciya-nacionalnyj-park-chinkve-terre.jpg",
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
    {
      image: "",
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
    {
      image:
        "https://w-dog.ru/wallpapers/9/15/323582683371937/manarola-noch-provinciya-la-speciya-liguriya-severnaya-italiya-zvezdy-gorod-italiya-region-liguriya-provinciya-speciya-nacionalnyj-park-chinkve-terre.jpg",
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
  ],
  description: [
    {
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
    {
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
    {
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
  ],
  faq: [
    {
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
    {
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
    {
      title: "Enterprise Mobility\n",
      description: `With an ever-growing penetration of Android devices, the demand for enterprise apps for this platform has also increased. Following the business development strategy and application requirements of the clients, we create custom Android solutions that address their needs.`,
    },
  ],
};
export const CommonFeaturePage = ({ data }) => {
  const { t } = useContext(TranslateContext);
  return (
    <div className={style.container}>
      <Header style={{ backgroundColor: "white" }}>
        <a>{t("header.portfolio")}</a>
        <a>{t("header.stages")}</a>
        <a>{t("header.reviews")}</a>
        <a>{t("header.order")}</a>
        <a>{t("header.for-clients")}</a>
      </Header>
      <div className={`${style["usp-block"]} ${style["padding-container"]} `}>
        <div className={"text__size_title text__color_blue"}>
          Key Services We Offer
        </div>
        <div className={style["usp-container"]}>
          {data.usp.map((it) => (
            <div className={style["usp-item"]}>
              <img src={it.image} className={style["usp-item__image"]}></img>
              <div
                className={`${style["usp-item__title"]} text__size_subtitle text__color_blue`}
              >
                {it.title}
              </div>
              <div
                className={`${style["usp-item__description"]} text__color_blue`}
              >
                {it.description}
              </div>
            </div>
          ))}
        </div>
      </div>
      <img className={style.banner} src={data.image}></img>
      <div
        className={`${style["description-block"]} ${style["padding-container"]} width__full`}
      >
        {data.description.map((it) => (
          <div className={style["description-item"]}>
            <div
              className={`${style["description-item__title"]} text__size_subtitle text__color_blue`}
            >
              {it.title}
            </div>
            <div
              className={`${style["description-item_description"]} text__color_blue`}
            >
              {it.description}
            </div>
          </div>
        ))}
      </div>
      <div className={accordeon["accordeon-menu"]}>
        <div
          className={`${style["faq__title"]} text__size_title text__color_blue`}
        >
          FAQ
        </div>
        {data.faq.map((it) => (
          <AccordionItem data={it} />
        ))}
      </div>

      <Feedback style={{ overflow: "auto", height: "auto" }} />
    </div>
  );
};

const AccordionItem = ({ data, isOpen = undefined, setIsOpen = undefined }) => {
  const ref = useRef(null);
  const [_isOpen, _setIsOpen] = useState(false);
  const opened = isOpen !== undefined ? isOpen : _isOpen;
  const { height } = useRefSize(ref, []);
  return (
    <div
      className={`${accordeon["accordeon"]} ${
        opened ? accordeon["isOpen"] : ""
      }`}
    >
      <button
        onClick={() => (setIsOpen || _setIsOpen)((state) => !state)}
        className={accordeon["accordeon__button"]}
      >
        <span className="text__color_blue text__size_subtitle-small">
          {data.title}
        </span>
        <div className={`${accordeon["icon"]}`}></div>
      </button>
      <div
        className={accordeon["accordeon__content"]}
        style={{ height: opened ? height : 0 }}
      >
        <div ref={ref} className={accordeon["accordeon__content-inner"]}>
          <p className={"text__color_blue"}>{data.description}</p>
        </div>
      </div>
    </div>
  );
};
